import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ed41c4a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "account-menu-container" };
const _hoisted_2 = { class: "account-menu" };
const _hoisted_3 = {
    key: 0,
    class: "account"
};
const _hoisted_4 = {
    class: "button",
    href: "/settings"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-cog menu-item__icon menu-item__icon--tooltip" }, null, -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-cog menu-item__icon" }, null, -1 /* HOISTED */));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "header-link-copy" }, "Settings", -1 /* HOISTED */));
const _hoisted_8 = {
    key: 1,
    id: "js-client-name-selector",
    class: "client-name-selector"
};
const _hoisted_9 = { class: "account" };
const _hoisted_10 = { class: "js-user-initial-name account__initial-name" };
const _hoisted_11 = {
    id: "js-user-name-dropdown",
    class: "account__user-name"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "header-link-caret" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-chevron-right" })
], -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", { href: "/notifications" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-bell" }),
    /*#__PURE__*/ _createElementVNode("span", null, "Notifications")
], -1 /* HOISTED */));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "/zendesk-login",
    target: "_blank"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-external-link" }),
    /*#__PURE__*/ _createElementVNode("span", null, "Help")
], -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-folder" }, null, -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "View Production Data", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_15,
    _hoisted_16
];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-laptop-code" }, null, -1 /* HOISTED */));
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "View Test Data", -1 /* HOISTED */));
const _hoisted_20 = [
    _hoisted_18,
    _hoisted_19
];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-sign-out" }, null, -1 /* HOISTED */));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Log Out", -1 /* HOISTED */));
const _hoisted_23 = [
    _hoisted_21,
    _hoisted_22
];
import { ElDropdown, ElDropdownMenu, ElDropdownItem } from "element-plus";
import ClientSelector from "./ClientSelector.vue";
import Session from "js/Session";
import NotificationBubble from "./NotificationBubble.vue";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AccountContainer',
    props: {
        isNavbarCollapsed: { type: Boolean }
    },
    setup(__props) {
        const SUPER_USER_PREFIX = /^su./;
        const session = Session.getInstance();
        const clients = session.getClients();
        const isSuperUser = session.isSuperUser();
        const isUserSupportUser = session.isUserSupportUser();
        const isSelfServiceUser = session.isSelfServiceUser();
        const modeService = session.getModeService();
        const isTestMode = modeService.isTestMode();
        const hasClientSelector = isSuperUser || clients.length > 1;
        const email = session.getEmail();
        const initials = email.replace(SUPER_USER_PREFIX, "").substring(0, 1);
        const props = __props;
        const setMode = (mode) => {
            modeService.setMode(mode);
        };
        const logout = () => {
            session.logout();
        };
        const popperOptions = computed(() => {
            return {
                placement: "right-start",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [props.isNavbarCollapsed ? 130 : 190, -20],
                        },
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: "viewport",
                        },
                    },
                ],
                strategy: "fixed",
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                    (!_unref(isUserSupportUser) && !_unref(isSelfServiceUser))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                            _createElementVNode("a", _hoisted_4, [
                                _createVNode(Tooltip, { message: "Settings" }, {
                                    default: _withCtx(() => [
                                        _hoisted_5
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _hoisted_6,
                                _hoisted_7
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    (_unref(hasClientSelector))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                            _createVNode(ClientSelector)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("li", _hoisted_9, [
                        _createVNode(_unref(ElDropdown), {
                            class: "button dropdown",
                            trigger: "click",
                            size: "large",
                            placement: "right-start",
                            "popper-class": "list list--drop-down list--drop-down--modern test__user-dropdown",
                            "popper-options": popperOptions.value
                        }, {
                            dropdown: _withCtx(() => [
                                _createVNode(_unref(ElDropdownMenu), null, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ElDropdownItem), null, {
                                            default: _withCtx(() => [
                                                _hoisted_13
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_unref(ElDropdownItem), null, {
                                            default: _withCtx(() => [
                                                _hoisted_14
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        (!_unref(isUserSupportUser) && !_unref(isSelfServiceUser))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (_unref(isTestMode))
                                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 0 }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[0] || (_cache[0] = ($event) => (setMode('production')))
                                                            }, _hoisted_17)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }))
                                                    : (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 1 }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[1] || (_cache[1] = ($event) => (setMode('test')))
                                                            }, _hoisted_20)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }))
                                            ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true),
                                        _createVNode(_unref(ElDropdownItem), null, {
                                            default: _withCtx(() => [
                                                _createElementVNode("a", {
                                                    class: "js-logout-button",
                                                    onClick: _withModifiers(logout, ["prevent"])
                                                }, _hoisted_23)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(NotificationBubble),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(initials)), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(email)), 1 /* TEXT */),
                                _hoisted_12
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["popper-options"])
                    ])
                ])
            ]));
        };
    }
});
